import { put } from 'redux-saga/effects'
import { TypeKeys as generalTypes } from '../modules/general/constants'

export function* fetchUsers() {
  yield put({
    type: generalTypes.REQUEST_DATA,
    payload: {
      resource: 'users',
      params: {
        include_archived: true,
      },
    },
  })
}
